import * as React from "react";
import { lazy, Suspense } from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";

const SuspenseFallback = () => {
    return <div className="grid-container">
        <div className="grid-x grid-padding-x">
            <div className="cell text-center">
                <i className="fa-solid fa-spinner fa-spin"></i>
            </div>
        </div>
    </div>
}


const JobsBannerSearch = lazy(() => import(/* webpackChunkName: "JobsBannerSearch" */"./components/JobsBannerSearch"));
const JobsListing = lazy(() => import(/* webpackChunkName: "JobsListing" */ "./components/JobsListing"));
const SearchRedirect = lazy(() => import(/* webpackChunkName: "SearchRedirect" */ "./components/SearchRedirect"));
const SearchJoinBlakes = lazy(() => import(/* webpackChunkName: "SearchJoinBlakes" */"./components/SearchJoinBlakes"));

const globalAny: any = global;

globalAny.React = React;
globalAny.ReactDOM = ReactDOM;
globalAny.ReactDOMClient = ReactDOMClient;

globalAny.JobsBannerSearch = (props: any) => (<Suspense fallback={<SuspenseFallback />}><JobsBannerSearch {...props} /></Suspense>);
globalAny.JobsListing = (props: any) => (<Suspense fallback={<SuspenseFallback />}><JobsListing {...props} /></Suspense>);
globalAny.SearchRedirect = (props: any) => (<Suspense fallback={<SuspenseFallback />}><SearchRedirect {...props} /></Suspense>);
globalAny.SearchJoinBlakes = (props: any) => (<Suspense fallback={<SuspenseFallback />}><SearchJoinBlakes {...props} /></Suspense>);


export default global;